import { useState } from 'react';
import { REMEMBERED_SITE_KEY, SITE_VALUES } from '../constants/auth.constants';
import type { Site } from '../types/auth.types';

const DEFAULT_SITE: Site = 'general';

function readRememberedSite(): Site {
  try {
    const stored = localStorage.getItem(REMEMBERED_SITE_KEY);
    return SITE_VALUES.find((site) => site === stored) ?? DEFAULT_SITE;
  } catch {
    return DEFAULT_SITE;
  }
}

function writeRememberedSite(site: Site): void {
  try {
    localStorage.setItem(REMEMBERED_SITE_KEY, site);
  } catch {
    return;
  }
}

interface UseRememberedSite {
  rememberedSite: Site;
  persistSite: (site: Site) => void;
}

export function useRememberedSite(): UseRememberedSite {
  const [rememberedSite] = useState(readRememberedSite);

  return { rememberedSite, persistSite: writeRememberedSite };
}
